import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=fd844d36&scoped=true"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=fd844d36&prod&scoped=css&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd844d36",
  null
  
)

export default component.exports